<div class="row">
  <div class="col s12 m6 l3">
    <ul class="list">
      <li class="heading">{{ 'nouns.usedInCustomizations' | translate }}</li>
      <li *ngFor="let cust of document.customizations">
        {{ cust.name }}
      </li>
    </ul>
  </div>
</div>
